// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {toast} from 'react-toastify'
import FlashMessage from '../components/FlashMessage'
import React from 'react'

export const ERROR_TOAST_MESSAGE = 'error_toast_message'
export const WARNING_TOAST_MESSAGE = 'warning_toast_message'
export const SUCCESS_TOAST_MESSAGE = 'success_toast_message'

const TTL = 5000

export function errorToast (message, closeButton = true) {
  return (dispatch) => {
    toast.error(<FlashMessage message={message} type='error'/>, {
      containerId: 'top-center',
      position: 'top-center',
      autoClose: TTL,
      pauseOnFocusLoss: true,
      className: 'error-toast',
      bodyClassName: 'error-toast-body',
      progressClassName: 'error-toast-progress-bar',
      closeButton: closeButton,
      draggable: false,
      hideProgressBar: true
    })
    dispatch({type: ERROR_TOAST_MESSAGE})
  }
}

export function warningToast (message, closeButton = true) {
  return (dispatch) => {
    toast.warn(<FlashMessage message={message} type='warning' />, {
      containerId: 'top-center',
      position: 'top-center',
      autoClose: TTL,
      pauseOnFocusLoss: true,
      className: 'warning-toast',
      bodyClassName: 'warning-toast-body',
      progressClassName: 'warning-toast-progress-bar',
      closeButton: closeButton,
      draggable: false,
      hideProgressBar: true
    })
    dispatch({type: WARNING_TOAST_MESSAGE})
  }
}

export function successToast (message, closeButton = true) {
  return (dispatch) => {
    toast.warn(<FlashMessage message={message} type='success' />, {
      containerId: 'top-center',
      position: 'top-center',
      autoClose: TTL,
      pauseOnFocusLoss: true,
      className: 'success-toast',
      bodyClassName: 'success-toast-body',
      progressClassName: 'success-toast-progress-bar',
      closeButton: closeButton,
      draggable: false,
      hideProgressBar: true
    })
    dispatch({type: SUCCESS_TOAST_MESSAGE})
  }
}
